import type { Middleware } from '@reduxjs/toolkit';

/**
 * Middleware para logging de acciones en desarrollo
 */
export const loggerMiddleware: Middleware = (store) => (next) => (action) => {
  if (
    import.meta.env.DEV && action && typeof action === 'object' &&
    'type' in action
  ) {
    const prevState = store.getState();
    const result = next(action);
    const nextState = store.getState();

    // eslint-disable-next-line no-console
    console.group(`%c${String(action.type)}`, 'color: #4CAF50; font-weight: bold;');
    // eslint-disable-next-line no-console
    console.log('%cPrevious State:', 'color: #FF9800; font-weight: bold;', prevState);
    // eslint-disable-next-line no-console
    console.log('%cAction:', 'color: #2196F3; font-weight: bold;', action);
    // eslint-disable-next-line no-console
    console.log('%cNext State:', 'color: #4CAF50; font-weight: bold;', nextState);
    // eslint-disable-next-line no-console
    console.groupEnd();

    return result;
  }

  return next(action);
};

/**
 * Middleware para notificaciones automáticas
 */
export const notificationMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  if (action && typeof action === 'object' && 'type' in action) {
    const actionType = String(action.type);

    // Auto-mostrar notificaciones para acciones async
    if (actionType.endsWith('/fulfilled')) {
      const actionName = actionType.replace('/fulfilled', '');

      // Solo para ciertas acciones importantes
      if (['counter/incrementAsync', 'counter/fetchFromAPI'].includes(actionName)) {
        store.dispatch({
          type: 'ui/addNotification',
          payload: {
            type: 'success',
            title: 'Operación completada',
            message: `${actionName} ejecutado correctamente`,
            duration: 3000,
          },
        });
      }
    }

    if (actionType.endsWith('/rejected')) {
      const rawPayload = 'payload' in action ? (action as any).payload : null;
      const errorMessage = typeof rawPayload === 'string'
        ? rawPayload
        : (rawPayload && typeof rawPayload === 'object'
          ? (rawPayload.description || rawPayload.message || rawPayload.error || 'Error desconocido')
          : 'Error desconocido');
      store.dispatch({
        type: 'ui/addNotification',
        payload: {
          type: 'error',
          title: 'Error en operación',
          message: errorMessage,
          duration: 5000,
        },
      });
    }
  }

  return result;
};

/**
 * Middleware para persistencia automática de preferencias
 */
export const persistenceMiddleware: Middleware = () => (next) => (action) => next(action);

export * from './';